import React from 'react';
import { Route, Routes } from 'react-router-dom';
import Login from './components/Login';
import AuditDashboard from './components/AuditDashboard';
import ReviewHistory from './components/ReviewHistory';
import ReviewRules from './components/ReviewRules';
import './App.css'
import { AuditHistoryDetail } from './components/AuditHistoryDetail';
import LabManager from './components/LabManager';
import UserManager from './components/UserManager';

const App: React.FC = () => {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/dashboard" element={<AuditDashboard />} />
      <Route path="/review-history" element={<ReviewHistory />} />
      <Route path="/review-rules" element={<ReviewRules />} />
      <Route path="/labs" element={<LabManager />} />
      <Route path="/labs" element={<UserManager />} />
      <Route path="/users" element={<UserManager />} />
      <Route path="/audit-detail" element={<AuditHistoryDetail />} />
      {/* <Route path="/review-history-list" element={<ReviewHistoryList />} /> */}
      <Route path="*" element={<Login />} />
    </Routes>
  );
};

export default App;